// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_w96","cls2":"ProfilePdfPackCard-cls2__3H ProfilePdfPackCard-cls1_w96"};